import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("karinox_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("karinox_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Co loi xay ra. Vui long thu lai.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatVND(amount) {
  if (!amount && amount !== 0) return "0";
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

/** Normalize phone: strip spaces/dashes/dots/parens, convert +84/84 prefix to 0.
 *  Use on blur / before submit. */
export function normalizePhone(raw) {
  if (!raw) return "";
  let s = String(raw).replace(/[\s.\-()]/g, "");
  if (s.startsWith("+84")) s = "0" + s.slice(3);
  else if (s.startsWith("84") && s.length > 9) s = "0" + s.slice(2);
  return s;
}

/** Prevent whitespace entry on phone inputs (onKeyDown). */
export function blockWhitespaceKey(e) {
  if (e.key === " " || e.key === "Spacebar") {
    e.preventDefault();
  }
}

/** Short format: 1.5M, 300K, 0 */
export function fmtVND(v) {
  if (!v) return "0";
  return v >= 1e6 ? `${(v / 1e6).toFixed(1)}M` : v >= 1e3 ? `${(v / 1e3).toFixed(0)}K` : `${v}`;
}

/** Full format with "đ": 1.500.000đ */
export function fmtFull(v) {
  if (!v && v !== 0) return "0đ";
  return new Intl.NumberFormat("vi-VN").format(v) + "đ";
}

export default api;
